import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getCategoriesList } from "../api/getCategoriesList";

export const useCategoriesListQuery = () => {
  return useQuery({
    queryKey: ["gamesCategories"],
    queryFn: getCategoriesList,
  });
};

export const invalidateCategoriesListQuery = () => {
  return queryClient.invalidateQueries({ queryKey: ["gamesCategories"] });
};
